import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import RegulationsStageTagsApi from '@/services/apiServiceModules/regulationsStageTagsApi.js'
const regulationsStageTagsApi = new RegulationsStageTagsApi()

export default class RegulationsStageTagsDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.REGULATIONS_STAGE_TAGS, regulationsStageTagsApi, {
			useCache: true,
		})
	}
}
